import { db, type LocalMomentsChunks } from './db'

export const storeMomentsChunksPayload = async (
  payload: LocalMomentsChunks,
) => {
  await db.momentsChunks.add(payload)
}

export const getMomentsChunksPayload = async () => {
  const payload = await db.momentsChunks.toArray()
  return payload
}

export const deleteMomentsChunksPayload = async () => {
  await db.momentsChunks.clear()
}

export const deleteMomentsChunksPayloadById = async (id: number) => {
  await db.momentsChunks.delete(id)
}
